import '@/App.css';
import { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Layout from '@/components/site/Layout';
import Home from '@/pages/Home';
import { PRODUCTS } from '@/data/content';

// Code-split secondary routes to shrink the initial JS bundle (Core Web Vitals)
const Products = lazy(() => import('@/pages/Products'));
const ProductDetail = lazy(() => import('@/pages/ProductDetail'));
const About = lazy(() => import('@/pages/About'));
const Infrastructure = lazy(() => import('@/pages/Infrastructure'));
const ManufacturingProcess = lazy(() => import('@/pages/ManufacturingProcess'));
const QualityAssurance = lazy(() => import('@/pages/QualityAssurance'));
const ExportMarkets = lazy(() => import('@/pages/ExportMarkets'));
const Career = lazy(() => import('@/pages/Career'));
const Contact = lazy(() => import('@/pages/Contact'));

// Preserve legacy WordPress URLs -> new routes (no 404s after migration)
const KNOWN = [
  '/',
  '/products',
  '/about',
  '/infrastructure',
  '/manufacturing-process',
  '/quality-assurance',
  '/export-markets',
  '/career',
  '/contact',
  ...PRODUCTS.map((p) => `/products/${p.slug}`),
];
const LEGACY_MAP = {
  '/quality-assurance-2': '/quality-assurance',
  '/home': '/',
  '/index': '/',
};

function LegacyRedirect() {
  const { pathname } = useLocation();
  const cleaned = pathname.replace(/^\/index\.php/, '').replace(/\/+$/, '') || '/';
  if (LEGACY_MAP[cleaned]) return <Navigate to={LEGACY_MAP[cleaned]} replace />;
  if (cleaned !== pathname && KNOWN.includes(cleaned)) return <Navigate to={cleaned} replace />;
  if (KNOWN.includes(cleaned) && cleaned !== '/') return <Navigate to={cleaned} replace />;
  return <Home />;
}

function App() {
  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div className="flex min-h-screen items-center justify-center bg-mist">
            <span className="mono-label text-steel">Loading…</span>
          </div>
        }
      >
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:slug" element={<ProductDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/infrastructure" element={<Infrastructure />} />
            <Route path="/manufacturing-process" element={<ManufacturingProcess />} />
            <Route path="/quality-assurance" element={<QualityAssurance />} />
            <Route path="/export-markets" element={<ExportMarkets />} />
            <Route path="/career" element={<Career />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<LegacyRedirect />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
